import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';

// Layouts
import DashboardLayout from './layouts/DashboardLayout';
import AdminLayout from './layouts/AdminLayout';

// Public & Auth Pages
import LandingPage from './pages/landing/LandingPage';
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import OnboardingPage from './pages/onboarding/OnboardingPage';
import PublicBusinessPage from './pages/public/PublicBusinessPage';

// Dashboard Pages
import DashboardOverview from './pages/dashboard/DashboardOverview';
import BusinessProfilePage from './pages/dashboard/BusinessProfilePage';
import ProductsPage from './pages/dashboard/ProductsPage';
import CategoriesPage from './pages/dashboard/CategoriesPage';
import ThemesPage from './pages/dashboard/ThemesPage';
import DigitalCardPage from './pages/dashboard/DigitalCardPage';
import QRCodePage from './pages/dashboard/QRCodePage';
import EnquiriesPage from './pages/dashboard/EnquiriesPage';
import SettingsPage from './pages/dashboard/SettingsPage';

// Admin Pages
import AdminDashboard from './pages/admin/AdminDashboard';

// Styles
import './styles/global.css';
import './styles/public-themes.css';

function App() {
  return (
    <ToastProvider>
      <AuthProvider>
        <Routes>
          {/* Public SaaS Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/setup-business" element={<OnboardingPage />} />
          <Route path="/business/:slug" element={<PublicBusinessPage />} />

          {/* Protected Dashboard Routes */}
          <Route path="/dashboard" element={<DashboardLayout />}>
            <Route index element={<DashboardOverview />} />
            <Route path="business" element={<BusinessProfilePage />} />
            <Route path="products" element={<ProductsPage />} />
            <Route path="categories" element={<CategoriesPage />} />
            <Route path="themes" element={<ThemesPage />} />
            <Route path="digital-card" element={<DigitalCardPage />} />
            <Route path="qr-code" element={<QRCodePage />} />
            <Route path="enquiries" element={<EnquiriesPage />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>

          {/* Protected Admin Routes */}
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
          </Route>

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </ToastProvider>
  );
}

export default App;
